import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./responsive-mobile.css";

// A plataforma web roda também dentro da WebView do app profissional. O app
// injeta esta marca no user-agent (applicationNameForUserAgent). Dentro do app,
// desligamos o Session Replay do Sentry — ele grava o DOM inteiro e é caro numa
// WebView mobile. A captura de erros do Sentry continua ligada normalmente.
const isDentroDoAppProfissional =
	typeof navigator !== "undefined" &&
	/Treinoio-Profissional-App/i.test(navigator.userAgent || "");

Sentry.init({
	dsn: "https://6abbd4028dbb7e1ece58b1c94fbea25b@o4509878978740224.ingest.us.sentry.io/4509878980968448",
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
	// Session Replay é caro na WebView (grava o DOM inteiro): só no navegador web.
	integrations: isDentroDoAppProfissional ? [] : [Sentry.replayIntegration()],
	replaysSessionSampleRate: isDentroDoAppProfissional ? 0 : 0.1,
	replaysOnErrorSampleRate: isDentroDoAppProfissional ? 0 : 1.0,
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
